import { render, staticRenderFns } from "./ProductsEditUser.vue?vue&type=template&id=2c132b05"
import script from "./ProductsEditUser.vue?vue&type=script&lang=js"
export * from "./ProductsEditUser.vue?vue&type=script&lang=js"
import style0 from "./ProductsEditUser.vue?vue&type=style&index=0&id=2c132b05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports